import { applyMiddleware, compose, createStore } from 'redux';
// import { reactReduxFirebase } from 'react-redux-firebase';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
// import { reduxFirestore } from 'redux-firestore';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { rootReducer } from './Root.reducer.js';
import { firebaseConfig } from '../config/Firebase.config.js';
// import { reactReduxFirebaseConfig } from '../config/ReactReduxFirebase.config.js';
import { initSagas, sagaMiddleware } from './Root.sagas.js';

const composeEnhancers = composeWithDevTools || compose;

firebase.initializeApp(firebaseConfig);

// Initialize other services on firebase instance
// firebase.firestore() // <- needed if using firestore
// firebase.functions() // <- needed if using httpsCallable

const middleware = [sagaMiddleware];

const initialState = {};

export const store = createStore(
  rootReducer(),
  initialState,
  composeEnhancers(
    // reactReduxFirebase(firebase, reactReduxFirebaseConfig),
    // reduxFirestore(firebase),
    applyMiddleware(...middleware)
  )
);

initSagas();
